import { render, staticRenderFns } from "./nomination-component.vue?vue&type=template&id=4ebceb98&scoped=true"
import script from "./nomination-component.ts?vue&type=script&lang=ts&external"
export * from "./nomination-component.ts?vue&type=script&lang=ts&external"
import style0 from "./nomination-component.scss?vue&type=style&index=0&id=4ebceb98&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebceb98",
  null
  
)

export default component.exports